/* global window, location */
'use strict';

import ApiActions from '../../../actions/api';
import Constants from './constants';
import Store from './store';
import btClient from 'braintree-web/client';
import { RootOrganizationId as RootOId } from '../../../../server/constants.js';


class Actions {

    static getTosDetails(id, store = Store, cb) {

        ApiActions.get(
            `/api/tos/${id}`,
            null,
            store,
            Constants.GET_TOS_DETAILS,
            Constants.GET_TOS_DETAILS_RESPONSE,
            cb
        );
    }

    static getTosAgreedResults(data, store = Store) {

        ApiActions.get(
            '/api/tos-agreed/my',
            data,
            store,
            Constants.GET_TOS_AGREED_RESULTS,
            Constants.GET_TOS_AGREED_RESULTS_RESPONSE
        );
    }

    static acceptTos(id, store = Store, cb) {

        ApiActions.post(
            `/api/tos-agreed/my`,
            { TOSId: id },
            store,
            Constants.CREATE_NEW_TOS_AGREED,
            Constants.CREATE_NEW_TOS_AGREED_RESPONSE,
            cb
        );
    }

    static postTokenAndCart(data, store = Store) {

        ApiActions.post(
            `/api/organizations/${RootOId}/orders`,
            data,
            store,
            Constants.POST_TOKEN_AND_CART,
            Constants.POST_TOKEN_AND_CART_RESPONSE,
            (err, response) => {
                if ( !err ) {
                    location = `/buynow/complete/${response.id}`;
                }

            }
        );
    }
    static resetTokenAndCard(store = Store) {
        store.dispatch({
            type: Constants.POST_TOKEN_AND_CARD_RESET
        });
    }

    static resetTokenAndCardUpdate(store = Store) {
        store.dispatch({
            type: Constants.POST_TOKEN_AND_CARD_UPDATE_RESET
        });
    }

    static postTokenAndCard(oId, data, store = Store, cb) {

        ApiActions.post(
            `/api/organizations/${oId}/payment-methods`,
            data,
            store,
            Constants.POST_TOKEN_AND_CARD,
            Constants.POST_TOKEN_AND_CARD_RESPONSE,
            cb
        );

    }

    static postTokenAndCardUpdate(oId, token, data, store = Store, cb) {


        ApiActions.put(
            `/api/organizations/${oId}/payment-methods/${token}`,
            data,
            store,
            Constants.POST_TOKEN_AND_CARD_UPDATE,
            Constants.POST_TOKEN_AND_CARD_UPDATE_RESPONSE,
            cb
        );

    }

    static deleteCard(oId, id, store = Store, cb) {

        ApiActions.delete(
            `/api/organizations/${oId}/payment-methods/${id}`,
            {},
            store,
            Constants.DELETE_CARD,
            Constants.DELETE_CARD_RESPONSE,
            cb,
            { id }
        );

    }

    static postTokenAndOrganization(data, store = Store, cb) {

        ApiActions.post(
            `/api/orders/organizations`,
            data,
            store,
            Constants.POST_TOKEN_AND_ORGANIZATION,
            Constants.POST_TOKEN_AND_ORGANIZATION_RESPONSE,
            (err, response) => {
                if ( cb ) {
                    cb(err, response);
                }
            }
        );

    }

    static getMyAccount(store = Store, cb) {

        ApiActions.get(
            '/api/accounts/mycheck',
            undefined,
            store,
            Constants.GET_MY_ACCOUNT,
            Constants.GET_MY_ACCOUNT_RESPONSE,
            cb
        );
    }

    static resetHostedFields(store = Store){

        store.dispatch({
            type: Constants.RESET_HOSTED_FIELDS
        });
    }

    static resetBtClient(store = Store){

        store.dispatch({
            type: Constants.RESET_BT_CLIENT
        });
    }
    static getBtToken(store = Store){

        ApiActions.get(
            '/api/braintree/token',
            null,
            store,
            Constants.GET_BT_TOKEN,
            Constants.GET_BT_TOKEN_RESPONSE,
            (err, response) => {
                if ( !err ){

                    store.dispatch({
                        type: Constants.CREATE_BT_CLIENT
                    });
                    btClient.create({
                        authorization: response.clientToken
                    }).then( (clientInstance) => {

                        store.dispatch({
                            type: Constants.CREATE_BT_CLIENT_RESULT,
                            client: clientInstance
                        });
                    }, (err) => {
                        store.dispatch({
                            type: Constants.CREATE_BT_CLIENT_RESULT,
                            err
                        });
                    });

                }

            }
        );
    }

    static createHostedFields(store = Store){
        store.dispatch({
            type:Constants.CREATE_HOSTED_FIELDS
        });
    }

    static createHostedFieldsResponse(err, hostedFieldsInstance, store = Store){
        store.dispatch({
            type:Constants.CREATE_HOSTED_FIELDS_RESULT,
            hostedFieldsInstance,
            err
        });
    }

    static submitHostedFields(store = Store){
        store.dispatch({
            type:Constants.SUBMIT_HOSTED_FIELDS
        });
    }
    static submitHostedFieldsResponse(err, store = Store){
        store.dispatch({
            type:Constants.SUBMIT_HOSTED_FIELDS_RESPONSE,
            err
        });
    }
    static submitLocalFields(store = Store){
        store.dispatch({
            type:Constants.SUBMIT_LOCAL_FIELDS
        });
    }
    static submitLocalFieldsResponse(err, store = Store){
        store.dispatch({
            type:Constants.SUBMIT_LOCAL_FIELDS_RESPONSE,
            err
        });
    }
}


export default Actions;
